<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
  history: { question: string; answer: string }[];
}>();
</script>

<template>
  <div class="tpl-zpl">
    <main class="tpl-zpl__canvas">
      <div v-if="quiz.sub_title" class="tpl-zpl__bubble tpl-zpl__bubble--bot">
        {{ quiz.sub_title }}
      </div>

      <template v-for="(h, i) in history" :key="i">
        <div class="tpl-zpl__bubble tpl-zpl__bubble--bot">{{ h.question }}</div>
        <div class="tpl-zpl__bubble tpl-zpl__bubble--user">{{ h.answer }}</div>
      </template>

      <slot />

      <footer class="tpl-zpl__footer">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy' }}
        </a>
        <p v-if="quiz.legal_name" class="tpl-zpl__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-zpl__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
